import Image from 'app/Components/Shared/Image/image';
import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {IconList, DwhActionType, DWHMessageText, DWHStatus} from '../../Constant/Constant';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import {resetState} from '../../TransferOrganizationAccountSlice';
import {getTime, getFormatDate} from '../../../../../utilities/dateUtils';
import {dwhGeneralReport} from '../../Reports/dwhReports';
import SimActionBtns from "app/Components/Block/TransferOrganizationAccountBlock/Popups/SimActionBtns";

const CreateSimOrderSuccessPage = (props) => {
  useEffect(() => {
    dwhGeneralReport({
      data: {...props.data, selectedHetPay: props.selectedHetPay, userDetails: props.userDetails},
      actionType: DwhActionType.SuccessScreenDeliveryRegularSIM,
      messageText: DWHMessageText.SuccessScreenDeliverySIM,
      status: DWHStatus.Completed,
    });
  }, []);

  const getDate = () => {
    var startDate = new Date(props.deliveryInfo.startDate);
    var endDate = new Date(props.deliveryInfo.endDate);
    return `ליום ${getFormatDate(startDate)} בין ${getTime(endDate)}- ${getTime(startDate)}`;
  };

  return (
    <div className='stepContainer messagePage'>
      <Image src={IconList.success} />
      <div>
        <p className='L_Title'>נוצרה הזמנה עבור SIM חדש</p>
        <sapn className='S_Title sec_m_top'>
          מספר הזמנה : <span className='bold'>{props.data.orderNum}</span>
        </sapn>
        <div className='purpleInfo'>
          <span>תואמה שליחות עבור {props.deliveryInfo.receiverFName + ' ' + props.deliveryInfo.receiverLName} </span>
          <br />
          <span>לכתובת {props.deliveryInfo.street + ' ' + props.deliveryInfo.houseNum + ', ' + props.deliveryInfo.city} </span>
          <br />
          <span>{getDate()}</span>
        </div>
        <span className='S_Title borderBox'>לאחר שה-SIM יגיע, יש להיכנס שוב לתהליך ולהפעיל את הקו עבור המנוי</span>
      </div>
      <BtnSubmit
        text={'הפעלת קו נוסף'}
        onclick={() => {
          props.resetState();
        }}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  data: state.TransferOrganizationAccount,
  deliveryInfo: state.TransferOrganizationAccount.deliveryInfo,
  selectedHetPay: state.portalsBlock.selectedHetPay,
  userDetails: state.authentication?.loginData?.userDetails,
});

const mapDispatchToProps = {
  resetState,
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateSimOrderSuccessPage);
